import { useState, useEffect, useContext, Fragment } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { AuthContext } from 'context';
import Heading from 'components/design-system/Heading/Heading';
import Text from 'components/design-system/Text/Text';
import ButtonComponent from 'components/design-system/Button/Button';
import IconComponent from 'components/design-system/icon/Icon';
import { CuadroIndicadoresSkeleton } from './componentes/CuadroIndicadoresSkeleton';
import imgHomeUser from 'assets/images/home/grafica-home-user.svg';
import { PlayCircleOutline, NavigateNext } from '@mui/icons-material';
import { formatoANumeroIngles } from 'helpers/formateoNumeros';
import useServices from './hooks/useServices';
import jwt from 'jwt-decode';
import { Cifra } from 'views/Indicadores/Reporte/Cifra';
import iconHomeDemandas from 'assets/images/home/homedemandas.svg';
import iconHomeOfertas from 'assets/images/home/homeofertas.svg';
import { ICON_NUMERO_TRANSACCIONES } from 'icons/ReporteIndicadores/IconNumeroTransacciones';
import { ICON_RESIDUO_VALORIZADO } from 'icons/ReporteIndicadores/IconResiduoValorizado';
import { ICON_CAMBIO_CLIMATICO } from 'icons/ReporteIndicadores/IconCambioClimatico';
import { ICON_MATERIAL_PARTICULADO } from 'icons/ReporteIndicadores/IconMaterialParticulado';
import { ICON_DEMANDA_ACUMULADA } from 'icons/ReporteIndicadores/IconDemandaAcumulada';
import { ICON_USUARIOS } from 'icons/ReporteIndicadores/IconUsuarios';
import { DICTONARY } from 'const/Dictonary';
import { RUTAS } from 'const/Rutas';
import PDF_FILE from './../../assets/anexo_tecnico_indicadores.pdf';
// decifrando jwt
const decifrarToken = token => {
  const decifrado = jwt(token);
  return decifrado;
};

const HomeSitio = props => {
  const { logged, logeduser, refrescarSesion } = useContext(AuthContext);
  const location = useLocation();
  const history = useHistory();

  const [verificaUsuarioNoRegistrado, setVerificaUsuarioNoRegistrado] =
    useState(localStorage.getItem('verificaUsuario') || false);

  // Si el usuario no está logueado y recibe un token, redirigir a la página de registro
  if (
    location.search !== '' &&
    !logged &&
    location.search.includes('token') &&
    verificaUsuarioNoRegistrado
  ) {
    const tokenCompleto = location.search;
    const token = location.search.split('=')[1];
    const tokenDecifrado = decifrarToken(tokenCompleto);
    const { correoElectronico, codigoSucursal } = tokenDecifrado;
    history.push(`${RUTAS.REGISTRARSE}?token=${token}`, {
      token: token,
      correoElectronico: correoElectronico,
      codigoSucursal: codigoSucursal
    });
  }

  // Si el usuario no está logueado y recibe un token y el state de verificandoCorrreo, redirigir a la página de registro
  useEffect(() => {
    if (location.state?.verificandoCorreo) {
      // console.log('presionar el botón de inicio de sesión');
      const { token } = location.state;
      refrescarSesion(token);
      // limpiar location.state
      history.replace({
        pathname: location.pathname,
        search: '',
        state: {}
      });
    }
  }, [
    history,
    location.pathname,
    location.search,
    location.state,
    location.state?.verificandoCorreo,
    refrescarSesion
  ]);

  const [indicadores, setIndicadores] = useState({
    marketplace: {
      aside: [],
      principal: []
    },
    gestiona: {
      aside: [],
      principal: []
    },
    usuarios: {},
    state: 'IDLE'
  });

  // Refactorización de carga de indicadores
  const {
    cargaUsuarios,
    cargaTransacciones,
    cargaResiduos,
    cargaResumenIndicadores,
    cargarDeclaraciones,
    cargaAmbiental,
    isLoadingUsuarios,
    isLoadingTransacciones,
    isLoadingResiduos,
    isLoadingResumen,
    isLoadingDeclarado,
    isLoadingAmbiental,
    dataUsuario,
    dataTransaccion,
    dataResiduo,
    dataResumen,
    dataDeclarado,
    dataAmbiental
  } = useServices();

  useEffect(() => {
    cargaUsuarios();
    cargaTransacciones();
    cargaResiduos();
    cargaResumenIndicadores();
    cargarDeclaraciones();
    cargaAmbiental();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setIndicadores({
      marketplace: {
        aside: [
          {
            titulo: 'Nº TRANSACCIONES',
            descripcion: 'Transacciones',
            icon: <ICON_NUMERO_TRANSACCIONES />,
            isLoading: isLoadingTransacciones,
            valor: dataTransaccion?.transaccion
              ? formatoANumeroIngles(dataTransaccion.transaccion.toString())
              : '-'
          },
          {
            titulo: 'RESIDUOS VALORIZADOS',
            descripcion: 'ton',
            icon: <ICON_RESIDUO_VALORIZADO />,
            isLoading: isLoadingResiduos,
            valor: dataResiduo?.residuo?.valorizado
              ? formatoANumeroIngles(dataResiduo.residuo.valorizado.toString())
              : '-'
          }
        ],
        destacado: {
          titulo: 'CAMBIO CLIMÁTICO',
          descripcion: 'kg CO2eq',
          icon: <ICON_CAMBIO_CLIMATICO />,
          isLoading: isLoadingAmbiental,
          valor: dataAmbiental?.ambiental?.marketplace.ambientalCambioClimatico
            ? formatoANumeroIngles(
                dataAmbiental.ambiental.marketplace.ambientalCambioClimatico.toString()
              )
            : '-'
        },
        principal: [
          {
            titulo: 'AGOTAMIENTO DE RECURSO FÓSIL',
            descripcion: 'kg petróleo eq',
            icon: <ICON_CAMBIO_CLIMATICO />,
            isLoading: isLoadingAmbiental,
            valor: dataAmbiental?.ambiental?.marketplace.ambientalRecursoFosil
              ? formatoANumeroIngles(
                  dataAmbiental.ambiental.marketplace.ambientalRecursoFosil.toString()
                )
              : '-'
          },
          {
            titulo: 'FORMACIÓN DE MATERIAL PARTICULADO',
            descripcion: 'kgmp 2,5eq',
            icon: <ICON_MATERIAL_PARTICULADO />,
            isLoading: isLoadingAmbiental,
            valor: dataAmbiental?.ambiental?.marketplace
              .ambientalMaterialParticulado
              ? formatoANumeroIngles(
                  dataAmbiental.ambiental.marketplace.ambientalMaterialParticulado.toString()
                )
              : '-'
          },
          {
            titulo: 'DEMANDA ACUMULADA DE ENERGÍA',
            descripcion: 'MJ eq',
            icon: <ICON_DEMANDA_ACUMULADA />,
            isLoading: isLoadingAmbiental,
            valor: dataAmbiental?.ambiental?.marketplace
              .ambientalDemandaAcumulada
              ? formatoANumeroIngles(
                  dataAmbiental.ambiental.marketplace.ambientalDemandaAcumulada.toString()
                )
              : '-'
          }
        ]
      },
      gestiona: {
        aside: [
          {
            titulo: 'Nº DECLARACIONES',
            descripcion: 'declaraciones',
            icon: <ICON_NUMERO_TRANSACCIONES />,
            isLoading: isLoadingDeclarado,
            valor: dataDeclarado?.declarado
              ? formatoANumeroIngles(dataDeclarado.declarado.toString())
              : '-'
          },
          {
            titulo: 'RESIDUOS DECLARADOS',
            descripcion: 'ton',
            icon: <ICON_RESIDUO_VALORIZADO />,
            isLoading: isLoadingResiduos,
            valor: dataResiduo?.residuo?.declarado
              ? formatoANumeroIngles(dataResiduo.residuo.declarado.toString())
              : '-'
          }
        ],
        destacado: {
          titulo: 'CAMBIO CLIMÁTICO',
          descripcion: 'kg CO2eq',
          icon: <ICON_CAMBIO_CLIMATICO />,
          isLoading: isLoadingAmbiental,
          valor: dataAmbiental?.ambiental?.gestiona.ambientalCambioClimatico
            ? formatoANumeroIngles(
                dataAmbiental.ambiental.gestiona.ambientalCambioClimatico.toString()
              )
            : '-'
        },
        principal: [
          {
            titulo: 'AGOTAMIENTO DE RECURSO FÓSIL',
            descripcion: 'kg petróleo eq',
            icon: <ICON_CAMBIO_CLIMATICO />,
            isLoading: isLoadingAmbiental,
            valor: dataAmbiental?.ambiental?.gestiona.ambientalRecursoFosil
              ? formatoANumeroIngles(
                  dataAmbiental.ambiental.gestiona.ambientalRecursoFosil.toString()
                )
              : '-'
          },
          {
            titulo: 'FORMACIÓN DE MATERIAL PARTICULADO',
            descripcion: 'kgmp 2,5eq',
            icon: <ICON_MATERIAL_PARTICULADO />,
            isLoading: isLoadingAmbiental,
            valor: dataAmbiental?.ambiental?.gestiona
              .ambientalMaterialParticulado
              ? formatoANumeroIngles(
                  dataAmbiental.ambiental.gestiona.ambientalMaterialParticulado.toString()
                )
              : '-'
          },
          {
            titulo: 'DEMANDA ACUMULADA DE ENERGÍA',
            descripcion: 'MJ eq',
            icon: <ICON_DEMANDA_ACUMULADA />,
            isLoading: isLoadingAmbiental,
            valor: dataAmbiental?.ambiental?.gestiona.ambientalDemandaAcumulada
              ? formatoANumeroIngles(
                  dataAmbiental.ambiental.gestiona.ambientalDemandaAcumulada.toString()
                )
              : '-'
          }
        ]
      },
      usuarios: {
        titulo: 'USUARIOS REGISTRADOS',
        descripcion: 'usuarios',
        icon: <ICON_USUARIOS />,
        isLoading: isLoadingUsuarios,
        valor: dataUsuario.usuario
          ? formatoANumeroIngles(dataUsuario.usuario.toString())
          : '-'
      }
    });

    // Almacenar indicadores en localStorage
    localStorage.setItem(
      'indicadores',
      JSON.stringify({
        usuario: dataUsuario?.usuario,
        transaccion: dataTransaccion?.transaccion,
        residuo: dataResiduo?.residuo,
        reduccionCambioClimatico:
          dataAmbiental?.ambiental?.reduccionCambioClimatico,
        reduccionRecursoFosil: dataAmbiental?.ambiental?.reduccionRecursoFosil,
        reduccionMaterialParticulado:
          dataAmbiental?.ambiental?.reduccionMaterialParticulado,
        reduccionDemandaAcumulada:
          dataAmbiental?.ambiental?.reduccionDemandaAcumulada,
        demanda: dataResumen?.resumen?.demanda,
        oferta: dataResumen?.resumen?.oferta,
        residuoDeclarado: dataResiduo?.residuo?.declarado
      })
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isLoadingUsuarios,
    isLoadingTransacciones,
    isLoadingResiduos,
    isLoadingAmbiental,
    isLoadingResumen,
    isLoadingDeclarado
  ]);

  useEffect(() => {
    // eliminar localStorage de indicadores cada 2 horas
    const interval = setInterval(() => {
      localStorage.removeItem('indicadores');
    }, 7200000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full bg-gradient-to-b from-[#EFF5F4] to-white mb-3 pt-3">
      <div className="px-4 md:container md:mx-auto">
        <div className="bg-white shadow-md rounded mb-5 mt-4">
          <div className="grid grid-cols-12 items-center">
            <div className="col-span-12 md:col-span-6 lg:col-span-4 p-5 md:py-10 md:px-12 bg-uv-primary-0">
              {!logged ? (
                <Heading type="h1" className="text-white mb-6 font-light">
                  Únete a la
                  <br />
                  <b className="font-semibold">Industria Circular</b>
                </Heading>
              ) : (
                <>
                  <Heading type="h1" className="text-white mb-6 font-light">
                    ¡Bienvenido/a
                    <br />
                    {logeduser.nombreUsuario ||
                      'Nombre de usuario no detectado'}
                    <br />a la plataforma de{' '}
                    <b className="font-semibold">Industria Circular</b>!
                  </Heading>
                  <Text
                    className="text-white opacity-80 tracking-wider font-normal"
                    size="L"
                  >
                    El Market Place permite conectar oportunidades de negocio
                    entre organizaciones para la reutilización y reciclado de
                    materias y residuos.
                  </Text>
                </>
              )}

              {!logged ? (
                <>
                  <div>
                    <Link to={RUTAS.REGISTRARSE}>
                      <ButtonComponent type="primary" className="mb-4">
                        Registro <NavigateNext />
                      </ButtonComponent>
                    </Link>
                  </div>
                  <div>
                    <a
                      href={DICTONARY.URL.PORTAL_DIFUSION_VIDEOS}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <ButtonComponent
                        type="ghost"
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        className="text-white hover:text-uv-primary-0 !bg-uv-primary-20"
                      >
                        Ver tutoriales{' '}
                        <PlayCircleOutline style={{ marginLeft: '10px' }} />
                      </ButtonComponent>
                    </a>
                  </div>
                </>
              ) : null}
            </div>
            <div
              className="hidden md:block md:col-span-6 lg:col-span-8 h-full bg-no-repeat bg-cover"
              style={{ backgroundImage: `url(${imgHomeUser})` }}
            ></div>
          </div>
        </div>

        <div className="mb-6">
          <Heading type="h3" className="font-bold text-uv-primary-0">
            Transacciones en módulo Marketplace
          </Heading>
          <div className="grid grid-cols-12 gap-4 mb-4">
            <div className="col-span-12 md:col-span-6">
              <Text>
                <b>Marketplace:</b> Puedes encontrar ofertas o requerimientos de
                recursos sub-utilizados (descartes, residuos), y servicios
                relacionados, y con ello aumentar tu circularidad y reducir
                costos de gestión de residuos.
              </Text>
            </div>
            <div className="col-span-12 md:col-span-6">
              <Text>El módulo permite:</Text>
              <ul>
                <li>
                  <Text className="relative pl-3">
                    <span className="w-1 h-1 bg-uv-secondary-0 inline-block rounded-full absolute left-0 top-2"></span>
                    Ofertar o requerir recursos sub-utilizados
                  </Text>
                </li>
                <li>
                  <Text className="relative pl-3">
                    <span className="w-1 h-1 bg-uv-secondary-0 inline-block rounded-full absolute left-0 top-2"></span>
                    Conectar con empresas
                  </Text>
                </li>
              </ul>
            </div>
          </div>

          <div className="flex shadow-md flex-col md:flex-row mb-6">
            <div className="w-full md:w-2/4 lg:w-1/4 bg-uv-primary-0 rounded-tl rounded-bl">
              <div className="px-6 py-4">
                {indicadores.marketplace.aside.map((indicador, index) => (
                  <div className="mb-8 mt-2" key={index}>
                    {indicador.isLoading ? (
                      <CuadroIndicadoresSkeleton />
                    ) : (
                      <>
                        <Text type="label" className="text-white mb-2">
                          {indicador.titulo ? indicador.titulo : ''}
                        </Text>
                        <div className="flex items-center">
                          {indicador.icon ? indicador.icon : ''}
                          <div className="pl-3">
                            <Heading type="H2" className="text-white my-0">
                              <Cifra
                                valor={indicador.valor ? indicador.valor : ''}
                              />
                            </Heading>
                            <Text className=" text-white leading-5 font-normal">
                              {indicador.descripcion
                                ? indicador.descripcion
                                : ''}
                            </Text>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="flex-grow w-auto px-6 py-4 bg-white rounded-tr rounded-br">
              <div className="grid grid-cols-12 items-center gap-4">
                <div className="col-span-12 lg:col-span-4">
                  <Heading
                    type="h3"
                    className="text-uv-secondary-0 font-bold mb-0 text-2xl"
                  >
                    Indicadores de
                    <br />
                    impacto ambiental
                  </Heading>
                </div>
                <div className="col-span-12 lg:col-span-8">
                  {indicadores.marketplace?.destacado?.isLoading ? (
                    <div className="w-full flex-wrap py-3">
                      <CuadroIndicadoresSkeleton />
                    </div>
                  ) : (
                    <IndicadorItem
                      size="big"
                      title={
                        indicadores.marketplace?.destacado?.titulo
                          ? indicadores.marketplace.destacado.titulo
                          : ''
                      }
                      value={
                        indicadores.marketplace?.destacado?.valor
                          ? indicadores.marketplace.destacado.valor
                          : ''
                      }
                      description={
                        indicadores.marketplace?.destacado?.descripcion
                          ? indicadores.marketplace.destacado.descripcion
                          : ''
                      }
                      icon={
                        indicadores.marketplace?.destacado?.icon
                          ? indicadores.marketplace.destacado.icon
                          : ''
                      }
                    />
                  )}
                </div>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-3 mt-2 gap-5">
                {indicadores.marketplace.principal.map((indicador, index) => (
                  <Fragment key={index}>
                    {indicador.isLoading ? (
                      <div className="w-full flex-wrap py-3">
                        <CuadroIndicadoresSkeleton />
                      </div>
                    ) : (
                      <IndicadorItem
                        title={indicador.titulo ? indicador.titulo : ''}
                        value={indicador.valor ? indicador.valor : ''}
                        description={
                          indicador.descripcion ? indicador.descripcion : ''
                        }
                        icon={indicador.icon ? indicador.icon : ''}
                      />
                    )}
                  </Fragment>
                ))}
              </div>
            </div>
          </div>

          <div className="grid grid-cols-12 gap-4 mb-4">
            <div className="col-span-12 md:col-span-6">
              <Heading type="h3" className="font-bold text-uv-primary-0">
                Declaración en módulo Gestiona
              </Heading>
              <Text>
                <b>Gestiona:</b> Puedes medir las “entradas” y “salidas”
                (residuos), y con ello el nivel de circularidad de tu empresa.
              </Text>
            </div>
            <div className="col-span-12 md:col-span-6">
              <Text>El módulo permite:</Text>
              <ul>
                <li>
                  <Text className="relative pl-3">
                    <span className="w-1 h-1 bg-uv-secondary-0 inline-block rounded-full absolute left-0 top-2"></span>
                    Crear y administrar compras de insumos
                  </Text>
                </li>
                <li>
                  <Text className="relative pl-3">
                    <span className="w-1 h-1 bg-uv-secondary-0 inline-block rounded-full absolute left-0 top-2"></span>
                    Crear y administrar la generación de residuos
                  </Text>
                </li>
                <li>
                  <Text className="relative pl-3">
                    <span className="w-1 h-1 bg-uv-secondary-0 inline-block rounded-full absolute left-0 top-2"></span>
                    Prospectar el impacto ambiental de la gestión
                  </Text>
                </li>
              </ul>
            </div>
          </div>

          <div className="flex shadow-md flex-col md:flex-row">
            <div className="w-full md:w-2/4 lg:w-1/4 bg-uv-primary-0 rounded-tl rounded-bl">
              <div className="px-6 py-4">
                {indicadores.gestiona.aside.map((indicador, index) => (
                  <div className="mb-8 mt-2" key={index}>
                    {indicador.isLoading ? (
                      <CuadroIndicadoresSkeleton />
                    ) : (
                      <>
                        <Text type="label" className="text-white mb-2">
                          {indicador.titulo ? indicador.titulo : ''}
                        </Text>
                        <div className="flex items-center">
                          {indicador.icon ? indicador.icon : ''}
                          <div className="pl-3">
                            <Heading type="H2" className="text-white my-0">
                              <Cifra
                                valor={indicador.valor ? indicador.valor : ''}
                              />
                            </Heading>
                            <Text className=" text-white leading-5 font-normal">
                              {indicador.descripcion
                                ? indicador.descripcion
                                : ''}
                            </Text>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="flex-grow w-auto px-6 py-4 bg-white rounded-tr rounded-br">
              <div className="grid grid-cols-12 items-center gap-4">
                <div className="col-span-12 lg:col-span-4">
                  <Heading
                    type="h3"
                    className="text-uv-secondary-0 font-bold mb-0 text-2xl"
                  >
                    Indicadores de
                    <br />
                    impacto ambiental
                  </Heading>
                </div>
                <div className="col-span-12 lg:col-span-8">
                  {indicadores.gestiona?.destacado?.isLoading ? (
                    <div className="w-full flex-wrap py-3">
                      <CuadroIndicadoresSkeleton />
                    </div>
                  ) : (
                    <IndicadorItem
                      size="big"
                      title={
                        indicadores.gestiona?.destacado?.titulo
                          ? indicadores.gestiona.destacado.titulo
                          : ''
                      }
                      value={
                        indicadores.gestiona?.destacado?.valor
                          ? indicadores.gestiona.destacado.valor
                          : ''
                      }
                      description={
                        indicadores.gestiona?.destacado?.descripcion
                          ? indicadores.gestiona.destacado.descripcion
                          : ''
                      }
                      icon={
                        indicadores.gestiona?.destacado?.icon
                          ? indicadores.gestiona.destacado.icon
                          : ''
                      }
                    />
                  )}
                </div>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-3 mt-2 gap-5">
                {indicadores.gestiona.principal.map((indicador, index) => (
                  <Fragment key={index}>
                    {indicador.isLoading ? (
                      <div className="w-full flex-wrap py-3">
                        <CuadroIndicadoresSkeleton />
                      </div>
                    ) : (
                      <IndicadorItem
                        title={indicador.titulo ? indicador.titulo : ''}
                        value={indicador.valor ? indicador.valor : ''}
                        description={
                          indicador.descripcion ? indicador.descripcion : ''
                        }
                        icon={indicador.icon ? indicador.icon : ''}
                      />
                    )}
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>

        {isLoadingResumen ? (
          <CuadroIndicadoresSkeleton />
        ) : (
          <div className="mb-6">
            <div className="flex shadow-md flex-col md:flex-row">
              <div className="grid grid-cols-12 shadow-md w-full">
                <div className="col-span-12 md:col-span-3 bg-uv-primary-0 rounded-tl rounded-bl px-6 py-6 mb-8 h-full">
                  <Text type="label" className="text-white mb-2">
                    {indicadores.usuarios.titulo
                      ? indicadores.usuarios.titulo
                      : ''}
                  </Text>
                  <div className="flex items-center">
                    <div className="w-14 h-14 rounded-full bg-uv-primary-10">
                      {indicadores.usuarios.icon
                        ? indicadores.usuarios.icon
                        : ''}
                    </div>
                    <div className="pl-3">
                      <Heading type="H2" className="text-white my-0">
                        <Cifra
                          valor={
                            indicadores.usuarios.valor
                              ? indicadores.usuarios.valor
                              : ''
                          }
                        />
                      </Heading>
                      <Text className=" text-white leading-5 font-normal">
                        {indicadores.usuarios.descripcion
                          ? indicadores.usuarios.descripcion
                          : ''}
                      </Text>
                    </div>
                  </div>
                </div>
                <div className="col-span-12 md:col-span-9 px-6 py-4 bg-white rounded-tr rounded-br">
                  <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-12 lg:col-span-6">
                      <div className="flex items-center">
                        <img
                          src={iconHomeOfertas}
                          alt="Ofertas recientes"
                          className="w-10"
                        />
                        <Heading
                          type="h3"
                          className="text-uv-secondary-0 font-bold ml-1.5"
                        >
                          Residuos ofertados más recientes
                        </Heading>
                      </div>
                      <ul className="pl-4">
                        {dataResumen?.resumen?.oferta?.map((oferta, i) => (
                          <li key={i} className="relative my-3 pl-4">
                            <div className="w-1.5 h-1.5 rounded-full bg-uv-secondary-0 absolute left-0 top-2"></div>
                            <Text className="text-sm font-normal">
                              {oferta}
                            </Text>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="col-span-12 lg:col-span-6">
                      <div className="flex items-center">
                        <img
                          src={iconHomeDemandas}
                          alt="Ofertas recientes"
                          className="w-10"
                        />
                        <Heading
                          type="h3"
                          className="text-uv-secondary-0 font-bold ml-1.5"
                        >
                          Residuos requeridos más recientes
                        </Heading>
                      </div>
                      <ul className="pl-4">
                        {dataResumen?.resumen?.demanda?.map((demanda, i) => (
                          <li key={i} className="relative my-3 pl-4">
                            <div className="w-1.5 h-1.5 rounded-full bg-uv-secondary-0 absolute left-0 top-2"></div>
                            <Text className="text-sm font-normal">
                              {demanda}
                            </Text>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="shadow-md bg-white p-5 mb-6">
          <Text className="mb-5">
            Todos los indicadores ambientales han sido calculados en base a
            información declarada por los usuarios o empresas, según la
            metodología, fuente de información y supuestos detallados en el
            anexo técnico descargable{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href={PDF_FILE}
              className="text-blue-700 underline"
            >
              aquí
            </a>
            . Los usuarios o empresas pueden descargar reportes customizados al
            registrarse y utilizar la plataforma.
          </Text>

          <Text>
            La plataforma también permite calcular indicadores sociales de horas
            de trabajo, paridad y salario generado por la valorización de
            residuos. Para obtener estos indicadores, o explorar otros
            indicadores sociales, puede escribirnos a{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="mailto:contacto@plataforma-industria-circular.cl"
              className="text-blue-700 underline"
            >
              contacto@plataforma-industria-circular.cl
            </a>{' '}
            con el asunto “solicitud de indicadores sociales”.
          </Text>
        </div>
      </div>
    </div>
  );
};

const IndicadorItem = ({ title, value, description, icon, size }) => {
  return (
    <div className="w-full flex-wrap py-3">
      <Text
        type="label"
        className={`text-uv-primary-0 mb-2 pr-3 ${
          size === 'big' ? 'text-sm' : ''
        } `}
      >
        {title}
      </Text>
      <div className="flex items-center">
        <IconComponent
          color="primary"
          className={`bg-uv-primary-90 rounded-full flex items-center justify-center
            ${size === 'big' ? 'w-20 h-20 p-3' : 'w-14 h-14 p-2.5'} 
          `}
        >
          {icon}
        </IconComponent>

        <div className="pl-3">
          <Heading
            type="H2"
            className={`font-bold my-0 ${size === 'big' ? 'text-3xl' : ''} `}
          >
            <Cifra valor={value} />
          </Heading>
          <Text className="text-black leading-5 font-normal">
            {description}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default HomeSitio;
